<template>
  <div class="event-time-list-item">
    <div class="event-symbol"></div>
    <div class="row event-date-source">
      <div class="event-date">{{data.time}}</div>
      <div>{{data.source}}</div>
    </div>
    <div>
      <a target="_blank" class="event-title" :href="data.url">{{data.title}}</a>
      <span v-if="data.count > 0" @click="onEmitNewsId(data.newsId)" class="related-news"><span class="related-news-icon"></span>相关文章</span>
    </div>

    <el-dialog
      title=''
      class="detail-dialog"
      :visible.sync="dialogVisible"
      width="800px"
      :modal="modal"
      top="10vh"
    >
      <div class="detail-dialog-header">
        <div class="title">{{title}}</div>
        <div class="row dialog-date-source">
          <div class="row">
            <div>{{date}}</div>
            <div class="source">{{source}}</div>
          </div>
          <div class="row">
            <el-switch inactive-color="#d1d2da" v-model="switchStatus"></el-switch>
            <div class="switch-title">线索高亮</div>
          </div>
        </div>
      </div>
      <div class="detail-dialog-content content" :class="{'detail-dialog-content-highlight': !switchStatus}">
        <div v-html="detail"></div>
      </div>
      <div class="detail-dialog-footer">
        <a class="url" :href="this.url" target="_blank">查看原文</a>
        <div class="warning">注意：点击"查看原文"将跳转至第三方源网站，可能存在原文地址失效无法访问的情况。</div>
      </div>
    </el-dialog>

    <div class="news-dialog">
      <el-dialog
        :visible.sync="similarityDialogVisible"
        width="814px"
        >
        <div class="news-dialog_title">相关新闻<span class="news-dialog_title-count">({{similarityTotalCount}}条)</span></div>
        <div class="news-list-box">
          <similarity-news-list-item v-for="(item, idx) in similarityResultData" :data="item" :key="idx"></similarity-news-list-item>
          <div class="no-data-container" v-if="!similarityTotalCount">
            <no-data></no-data>
          </div>
        </div>  
      </el-dialog>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import Mark from 'mark.js';
import SimilarityNewsListItem from '@/components/news-monitor/SimilarityNewsListItem';
import NoData from '@/components/common/NoData';

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      date: '',
      source: '',
      detail: '',
      url: '',
      instance: '',
      negativeHeight: [],
      positiveHeight: [],
      switchStatus: true,
      similarityDialogVisible: false,
      similarityTotalCount: 0,
      similarityResultData: []
    };
  },
  props: {
    data: {
      type: Object
    },
    modal: {
      default: true
    }
  },
  methods: {
    onEmitNewsId(newsId) {
      this.similarityDialogVisible = true;
      QuestionQuery.similarityNewsList(newsId).then(result => {
        this.similarityTotalCount = result.totalCount;
        this.similarityResultData = result.pageItems;
      });
    },
    onCheckDetailClick(id) {
      QuestionQuery.getNewsDetail(id).then(res => {
        const a = document.createElement('a');
        a.setAttribute('href', res.url);
        a.setAttribute('target', '_blank');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    }
  },
  components: {
    NoData,
    SimilarityNewsListItem
  },
  updated() {
    const instance = new Mark(document.querySelectorAll('.detail-dialog-content'));
    instance.mark(this.positiveHeight || [], {
      element: 'span',
      className: 'positive-height'
    });
    instance.mark(this.negativeHeight || [], {
      element: 'span',
      className: 'negative-height'
    });
  }
};
</script>

<style lang="scss" scoped>
  .event-time-list-item {
    position: relative;
    padding: 20px 14px;
    width: 100%;
    border-left: 2px solid #f7f7fa;
    .event-symbol {
      position: absolute;
      top: 25px;
      left: -5px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #45a8cc;
    }
    .event-date-source {
      margin-bottom: 4px;
      color: #747990;
      font-size: 12px;
      .event-date {
        margin-right: 16px;
      }
    }
    .event-title {
      color: #171f46;
      font-size: 14px;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .related-news-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right:2px;
      vertical-align: middle;
      background-image: url("../../assets/img/related-news.svg");
      background-size: cover;
    }
    .related-news {
      margin-left: 16px;
      font-size: 12px;
      color: #45a8cc;
      cursor: pointer;
      &:hover {
        color:#3cbeed;
        font-weight: bold;
      }
      &:active {
        color: #45a8cc;
        font-weight: bold;
      }
    }
  }
  /deep/.detail-dialog {
  .detail-dialog-header {
    padding: 32px 32px 26px;
    min-height: 114px;
    width: 100%;
    background-color: #f7f8fc;
    .title {
      margin-bottom: 12px;
      color: #171f46;
      font-size: 20px;
      font-weight: 500;
    }
    .dialog-date-source {
      line-height: 20px;
      justify-content: space-between;
      color: #747990;
      font-size: 12px;
      font-weight: 500;
      .source {
        margin-left: 16px;
      }
      .switch-title {
        margin-left: 8px;
        color: #464d6c;
      }
    }
  }
  .detail-dialog-content {
    padding: 24px 32px;
    height: 496px;
    overflow: auto;
    color: #464d6c;
    font-size:14px;
    line-height: 22px;
    background-color: #ffffff !important;
  }
  .detail-dialog-content-highlight span.positive-height{
    color: #464d6c !important;
  }
  .detail-dialog-content-highlight span.negative-height{
    color: #464d6c !important;
  }
  .detail-dialog-footer {
    padding: 16px 32px;
    background-color: #f7f8fc;
    .url {
      color: #45a8cc;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
    }
    .warning {
      margin-top: 4px;
      color: #747990;
      font-size: 12px;
    }
  }
  .el-dialog {
    background-color: #ffffff;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 680px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}
/deep/{
  .el-switch__core {
    width: 34px !important;
  }
  .el-switch__core:after {
    top: 3px;
    left: 3px;
    width: 12px;
    height: 12px;
    background-color: #e4e4e4;
  }
  .el-switch.is-checked .el-switch__core::after {
    margin-left: -14px;
  }
}

.news-dialog {
  &_title {
    height: 44px;
    line-height: 44px;
    padding-left: 24px;
    font-size: 14px;
    font-weight: 500;
    color: #171F46;
    box-shadow:0px 1px 0px 0px rgba(247,247,250,1);
  }
  .news-list-box {
    height: 656px;
    overflow-y: auto;
    .no-data-container {
      height: 500px;
    }
  }
  /deep/ .el-dialog__wrapper {
    background: rgba(0,0,0,0.4);
    .el-dialog {
      width: 900px;
      position: relative;
      margin-top: 13vh !important;
      border-radius: 8px;
      border: solid 1px #3e393b;
      .el-dialog__header {
        position: absolute;
        top: 0;
        right: 0px;
        .el-dialog__headerbtn {
          width: 24px;
          height: 24px;
          top: 12px;
          .el-dialog__close {
            color: #514d4f;
          }
        }
      }
      .el-dialog__body {
        background: #ffffff;
        padding: 0;
        .search-news-list-container {
          .filter {
            height: 54px;
            justify-content: center;
            span {
              display: none;
            }
            div{
              display: none;
            }
            border-bottom: 1px solid #4E4A4D;
            padding-bottom: 22px;
          }
          .result-container {
          height: 60vh;
          overflow-y: auto;
          margin-top: 0;
            .news-list-header {
              display: none;
            }
          }
        }
      }
    }
  }
}

</style>
